import WebHome from "../pages";
import Home from "../pages/Home";
import Login from "../pages/Auth/Login";
import AllAssets from "../pages/Assets";
import Signup from "../pages/Auth/Signup";
import MyAssets from "../pages/Assets/MyAssets";
import PageNotFound from "../pages/PageNotFound";
import Faq from "../pages/Content Management/Faq";
import SavedAsset from "../pages/Assets/SavedAsset";
import HelpSupport from "../pages/Auth/HelpSupport";
import AssetDetail from "../pages/Assets/AssetDetail";
import AccountSetting from "../pages/Account Setting";
import GetSecurPoint from "../pages/Auth/GetSecurPoint";
import ResetPassword from "../pages/Auth/ResetPassword";
import BrowseCategory from "../pages/Home/BrowseCategory";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import OtpVarification from "../pages/Auth/OtpVarification";
import PrivacyPolicy from "../pages/Content Management/PrivacyPolicy";
import TermsofService from "../pages/Content Management/TermsofService";
import OwnerDetail from "../pages/Assets/OwnerDetail";

export const webPaths = {
  WebHome: "/",
  Home: "/home",
  MyAssets: "/my-assets",
  AllAssets: "/all-assets",
  SavedAsset: "/saved-assets",
  AssetDetail: "/assets-detail/:id",
  PageNotFound: "/*",
  Login: "/log-in",
  Signup: "/sign-up",
  ResetPassword: "/reset-password",
  AccountSetting: "/account-setting/:type",
  ForgotPassword: "/forgot-password",
  OtpVarification: "/otp-verification",
  PrivacyPolicy: "/privacy-policy",
  TermsofService: "/terms-of-service",
  BrowseCategory: "/browse-category",
  GetSecurPoint: "/get-securpoint",
  HelpSupport: "/help-and-support",
  Faq: "/faq",
  OwnerDetail: "/user-detail/:id",
};

const webRoutes = [
  {
    label: "WebHome",
    path: webPaths?.WebHome,
    element: <WebHome />,
    isPrivate: false,
  },
  {
    label: "Login",
    path: webPaths?.Login,
    element: <Login />,
    isPrivate: false,
  },
  {
    label: "Signup",
    path: webPaths?.Signup,
    element: <Signup />,
    isPrivate: false,
  },
  {
    label: "ForgotPassword",
    path: webPaths?.ForgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    label: "OtpVarification",
    path: webPaths?.OtpVarification,
    element: <OtpVarification />,
    isPrivate: false,
  },
  {
    label: "ResetPassword",
    path: webPaths?.ResetPassword,
    element: <ResetPassword />,
    isPrivate: false,
  },
  {
    label: "Home",
    path: webPaths?.Home,
    element: <Home />,
    isPrivate: true,
  },
  {
    label: "MyAssets",
    path: webPaths?.MyAssets,
    element: <MyAssets />,
    isPrivate: true,
  },
  {
    label: "AllAssets",
    path: webPaths?.AllAssets,
    element: <AllAssets />,
    isPrivate: false,
  },
  {
    label: "SavedAsset",
    path: webPaths?.SavedAsset,
    element: <SavedAsset />,
    isPrivate: true,
  },
  {
    label: "AssetDetail",
    path: webPaths?.AssetDetail,
    element: <AssetDetail />,
    isPrivate: false,
  },
  {
    label: "AccountSetting",
    path: webPaths?.AccountSetting,
    element: <AccountSetting />,
    isPrivate: true,
  },
  {
    label: "Faq",
    path: webPaths?.Faq,
    element: <Faq />,
    isPrivate: false,
  },
  {
    label: "PrivacyPolicy",
    path: webPaths?.PrivacyPolicy,
    element: <PrivacyPolicy />,
    isPrivate: false,
  },
  {
    label: "TermsofService",
    path: webPaths?.TermsofService,
    element: <TermsofService />,
    isPrivate: false,
  },
  {
    label: "BrowseCategory",
    path: webPaths?.BrowseCategory,
    element: <BrowseCategory />,
    isPrivate: true,
  },
  {
    label: "GetSecurPoint",
    path: webPaths?.GetSecurPoint,
    element: <GetSecurPoint />,
    isPrivate: true,
  },
  {
    label: "HelpSupport",
    path: webPaths?.HelpSupport,
    element: <HelpSupport />,
    isPrivate: false,
  },
  {
    label: "PageNotFound",
    path: webPaths?.PageNotFound,
    element: <PageNotFound />,
    isPrivate: false,
  },
  {
    label: "OwnerDetail",
    path: webPaths?.OwnerDetail,
    element: <OwnerDetail />,
    isPrivate: false,
  },
];

export default webRoutes;
